'use client';

import { PublicCandidatesView } from '@/components/candidate/PublicCandidatesView';
import { VettingStory } from '@/components/company/VettingStory';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

function PublicCandidatesContent() {
  const searchParams = useSearchParams();
  const interviewId = searchParams.get('interview_id');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 font-domaine-narrow">
                Pre-Vetted Engineering Talent
              </h1>
              <p className="mt-2 text-sm text-gray-600">
                by Cruit Europe
                {interviewId && (
                  <span className="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                    Interview: {interviewId}
                  </span>
                )}
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Vetting Story */}
      <section className="bg-gradient-to-b from-[#2665eb] to-[#225ad3] py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <VettingStory />
        </div>
      </section>

      {/* Candidates Grid */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">
          Vetted Candidates
        </h2>
        <PublicCandidatesView />
      </main>
    </div>
  );
}

export default function PublicCandidatesPage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <PublicCandidatesContent />
    </Suspense>
  );
}
